import { useState, useEffect } from "react";

export const useIsMobile = () => {
    const isBrowser = typeof window !== "undefined";
    const [isMobile, setIsMobile] = useState(isBrowser ? window.innerWidth <= 768 : false);

    useEffect(() => {
        if (!isBrowser) return;

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isBrowser]);

    return isMobile;
};
